import { EducationalInvestmentCode, EducationalInvestment } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const TO_SUCCEED_STRINGS =
  appStrings.modules.educationalInvestment.educationalInvestmentCardToSucceed;

const EDUCATIONAL_INVESTMENT_DATA: Record<
  EducationalInvestmentCode,
  Pick<EducationalInvestment, 'icon' | 'toSucceed'>
> = {
  high_school_only: {
    icon: 'Award03',
    toSucceed: [...TO_SUCCEED_STRINGS.highSchoolOnly],
  },
  trade_technical_school: {
    icon: 'Tool02',
    toSucceed: [...TO_SUCCEED_STRINGS.tradeTechnicalSchool],
  },
  community_college: {
    icon: 'Certificate01',
    toSucceed: [...TO_SUCCEED_STRINGS.communityCollege],
  },
  less_selective_4_year: {
    icon: 'GraduationHat01',
    toSucceed: [...TO_SUCCEED_STRINGS.lessSelective4Year],
  },
  selective_4_year: {
    icon: 'GraduationHat01',
    toSucceed: [...TO_SUCCEED_STRINGS.selective4Year],
  },
  very_selective_4_year: {
    icon: 'GraduationHat02',
    toSucceed: [...TO_SUCCEED_STRINGS.verySelective4Year],
  },
  graduate_professional_school: {
    icon: 'Building08',
    toSucceed: [...TO_SUCCEED_STRINGS.graduateProfessionalSchool],
  },
  entrepreneurship: {
    icon: 'Stand',
    toSucceed: [...TO_SUCCEED_STRINGS.entrepreneurship],
  },
  early_career_apprenticeship: {
    icon: 'UserCheck02',
    toSucceed: [],
  },
  strong_major_focus: {
    icon: 'Certificate01',
    toSucceed: [],
  },
};

export const hydrateEducationalInvestment = (
  investment: EducationalInvestment,
): EducationalInvestment => {
  const data = EDUCATIONAL_INVESTMENT_DATA[investment.code];

  if (!data) {
    console.error('Unknown educational investment code:', investment.code);

    return investment;
  }

  return {
    ...investment,
    icon: data.icon,
    toSucceed: data.toSucceed,
  };
};
